import React from 'react'
import './styles.scss'

const Stat = ({component}: any) => {
  let value = component.defVal !== undefined ? component.val || component.defVal : component.val;
  if(component.valueID) value = component[component.valueID]
  if(component.formatter) {
    value = component.formatter(value, component)
  }
  const style = {
    fontWeight: component.bold ? 700 : 'normal',
    color: component.color ? component.color : 'inherit'
  }
  return (
    <div className="stat_component" style={style} id={component.id}>{value}</div>
  )
}

export default Stat
